import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Pipe } from 'pumpcalc-core';
import {Keys,Labels}  from '../gasflow.constants';

@Component({
  selector: 'app-range-variable',
  templateUrl: './range-variable.component.html',
  styleUrls: ['./range-variable.component.css']
})
export class RangeVariableComponent implements OnInit, OnChanges {

  @Input() pipes:Pipe[]=[];
  @Input() conditions:any={};
  @Input() errors:any={};
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  show1=false;
  variables=[];
  rangeVariables={};

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['conditions'] || changes['pipes']){
      this.variables=[];
      this.setVariableOptionsForPipes();
      this.setVariableOptionsForBoundaries();
      this.variables = this.variables.slice(0);
      this.clearInvalidRangeVariables();
    }

  }

  ngOnInit() {
  }

  setVariableOptionsForPipes(){
    this.pipes.forEach((pipe,i) =>{
      switch(pipe.section) {
        case Labels[Keys.circular] :
          this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.diameter],value:i+Keys.diameter,pipe:i+1,key:Keys.diameter})
        ;break;
        case Labels[Keys.rectangular] :
          this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.width],value:i+Keys.width,pipe:i+1,key:Keys.width})
          this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.height],value:i+Keys.height,pipe:i+1,key:Keys.height})
        ;break;
        case Labels[Keys.annular] : ;
          this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.insideDiameter],value:i+Keys.insideDiameter,pipe:i+1,key:Keys.insideDiameter})
          this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.radialGap],value:i+Keys.radialGap,pipe:i+1,key:Keys.radialGap})
        break;
      }
      this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.length],value:i+Keys.length,pipe:i+1,key:Keys.length})
      this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.bends],value:i+Keys.bends,pipe:i+1,key:Keys.bends})
      this.variables.push({name:"Pipe " + (i+1) + " " + Labels[Keys.parallel],value:i+Keys.parallel,pipe:i+1,key:Keys.parallel})
    })
  }

  setVariableOptionsForBoundaries(){
      Object.keys(this.conditions).forEach(key=>{
        this.variables.push({name:Labels[key],value:key,key:key,quantity:this.conditions[key].quantity})
      })
      this.variables.push({name:Labels[Keys.gasEntryTemperature],value:Keys.gasEntryTemperature,key:Keys.gasEntryTemperature})
    }

  valueChanged(event){
    this.rangeVariables[event.id]=event;
    this.valueChange.emit(this.rangeVariables);
  }

  clearInvalidRangeVariables(){
    let _rangeVariables={};
    Object.keys(this.rangeVariables).forEach(i=>{
      this.variables.forEach(variable=>{
        if(variable.key==this.rangeVariables[i].key && (this.rangeVariables[i].pipe? this.rangeVariables[i].pipe == variable.pipe:true) ){
          _rangeVariables[i]=this.rangeVariables[i];
        }
      })
    })
    this.rangeVariables = _rangeVariables;
    this.show1 = this.rangeVariables[1]?true:false;
    this.valueChange.emit(this.rangeVariables);
  }

  clear(i:number){
    let _rangeVariables ={};
    Object.keys(this.rangeVariables).forEach(key=>{
      if(key!=i+""){_rangeVariables[key]=this.rangeVariables[key]}
    })
    this.rangeVariables=_rangeVariables;
    this.valueChange.emit(this.rangeVariables);
  }

}
